import { Injectable } from '@angular/core';
import { Environment } from '../../config/environment';
import { ServiceRouter } from '../core/http-service-router.service';
import { Config } from '../../config/config';
import { METHOD_TYPE } from '../../constants/service.constants';
import { Observable } from 'rxjs';

/**
 * Show member account info interface
 */
interface ShowMemberAccountInfo {
	showMemberAccountInfo: boolean;
}

@Injectable({
	providedIn: 'root',
})
export class MemberInfoConfirmationService {
	constructor(
		private serviceRouter: ServiceRouter,
		private environment: Environment,
		private config: Config
	) {}

	/** decides to show member info modal or not */
	showMemberInfoModal(): Observable<ShowMemberAccountInfo> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().DASHBOARD_BASE_URL,
			this.config.url.dashboard.confirmMemberAccountInfo,
			METHOD_TYPE.SECURED_GET,
			''
		);
	}

	/** Service call to post confirmation status (whether user clicked yes or no)  */
	postConfirmation(body: any): Observable<any> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().DASHBOARD_BASE_URL,
			this.config.url.dashboard.confirmMemberAccountInfo,
			METHOD_TYPE.SECURED_POST,
			body
		);
	}
}
